export default {
  other: 'Other',
  testing: 'Testing',
  dealerTooSlow: 'Dealer too slow',
  noInAppPayment: 'No in-app payment',
  enteredWrongData: 'Entered wrong data',
  vehicleProblem: 'Vehicle problem',
  shopAboutToClose: 'Shop was about to close',
  incorrectInfo: 'Order contained incorrect information',
  fakeOrder: 'Fake order',
  consumerRequest: 'Consumer has requested the cancellation',
  missingPIN: 'PIN was not provided',
  invalidPhone: 'Invalid phone',
  invalidAddress: 'Invalid address',
};



// WEBPACK FOOTER //
// ../utils/labels/cancellation-reasons.js